import { hexToRgbA } from '../../../utils/hexToRGBA';
import { EventType } from './types';
import { eventTypeColorMap } from './useCalendarEvents';

export const getColorForEventTypes = (eventTypes: EventType[], fade?: boolean): string | undefined => {
    if (!eventTypes.length) return;

    const color = eventTypes.length === 1 ? eventTypeColorMap[eventTypes[0]] : eventTypeColorMap['all'];
    return hexToRgbA(color, fade ? 0.4 : 0.8);
};
